import {
    getServiceAsync,
    UpdateFavoriteFolderResponse,
    UpdateFavoriteOperationType,
} from '../../service';
import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../shared';

export function removeFavoritePublicFolder(folderId: string): Promise<boolean> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'RemoveFavoritePublicFolder',
            feature: Feature.FolderManagement,
            operation: () =>
                service.Operation.updateFavoriteFolder(
                    {
                        request: {
                            Folder: service.Factory.folder({
                                FolderId: service.Factory.folderId({ Id: folderId }),
                            }),
                            Operation: UpdateFavoriteOperationType.Remove,
                        },
                    },
                    fullResponseOperationOption
                ),
            transformResponse: (response: UpdateFavoriteFolderResponse) => response.WasSuccessful,
        })
    );
}
